"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Plugin = void 0;
const inversify_1 = require("inversify");
/**
 * Plugin decorator.
 */
const Plugin = () => {
    return (target) => {
        inversify_1.injectable()(target);
    };
};
exports.Plugin = Plugin;
//# sourceMappingURL=decorator.js.map